'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _reactRouterRedux = require('react-router-redux');

var _components = require('../../components');

var _DefaultString = require('../../helpers/DefaultString');

var _Authorization = require('../../helpers/Authorization');

var _ClientError = require('../../helpers/ClientError');

var _Login = require('../../helpers/Login');

var _Login2 = _interopRequireDefault(_Login);

var _Logs = require('../../helpers/Logs');

var _Provider = require('../../helpers/Provider');

var _Router = require('../../helpers/Router');

var _auth = require('../../redux/modules/auth');

var _Authorization2 = require('./Authorization.scss');

var _Authorization3 = _interopRequireDefault(_Authorization2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Authorization = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    appInfo: state.appInfo,
    auth: state.auth,
    log: state.log };
}, { startGracePeriod: _auth.startGracePeriod, pushState: _reactRouterRedux.push }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Authorization, _Component);

  function Authorization(props) {
    (0, _classCallCheck3.default)(this, Authorization);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Authorization.__proto__ || (0, _getPrototypeOf2.default)(Authorization)).call(this, props));

    _this.onAuthorize = function () {
      var path = _Authorization.AuthorizationHelper.authorizeNowPath(_this.state.provider);
      _this.props.pushState((0, _Router.getPath)(_Router.RouterConst.Welcome + '/' + path));
    };

    _this.onChangeProvider = function () {
      _this.props.pushState((0, _Router.getPath)(_Router.RouterConst.Welcome + '/' + _Router.RouterConst.TopProviders));
    };

    _this.onTrial = function () {
      _this.setState({ loading: true });
      _this.props.startGracePeriod(_this.state.provider.id);
    };

    _this.state = {
      canStartGracePeriod: _this.props.auth.userInfo ? _this.props.auth.userInfo.canStartGracePeriod : false,
      loading: false,
      provider: null
    };
    return _this;
  }

  (0, _createClass3.default)(Authorization, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      (0, _Provider.getProvider)(this.props.auth, function (result) {
        _this2.setState({ provider: result });
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.auth.startingGracePeriod && !nextProps.auth.startingGracePeriod) {
        if (!nextProps.auth.error) {
          (0, _Login2.default)(nextProps.auth.sessionId, nextProps.auth, this.props.log, this.props.appInfo, this.props.pushState, _Logs.LogEventSelectedOptions.Trial);
        } else {
          (0, _ClientError.createLoginClientError)(this.props.auth.error, new Error().stack, this.props.pushState, this.props.auth);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var canStartGracePeriod = this.state.canStartGracePeriod;

      return _react2.default.createElement(
        'div',
        { className: _Authorization3.default.authorization },
        _react2.default.createElement(
          'div',
          { className: _Authorization3.default.title },
          _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.Authorization)
        ),
        _react2.default.createElement(_components.ProviderLogo, { className: _Authorization3.default.providerLogo, provider: this.state.provider }),
        _react2.default.createElement(
          'div',
          { className: _Authorization3.default.message },
          _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.AuthorizationMessage)
        ),
        canStartGracePeriod ? _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_components.BaseButton, { className: _Authorization3.default.startDayTrial, onClick: function onClick() {
              return _this3.onTrial();
            }, buttonString: _DefaultString.translations.FreeTrial, loading: this.state.loading }),
          _react2.default.createElement(
            'div',
            { className: _Authorization3.default.startDayTrialMessage },
            _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.StartDayTrialMessage)
          ),
          _react2.default.createElement(
            'div',
            { className: _Authorization3.default.or },
            _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.Or)
          )
        ) : '',
        _react2.default.createElement(_components.BaseButton, { className: _Authorization3.default.authorizeNow, onClick: function onClick() {
            return _this3.onAuthorize();
          }, buttonString: _DefaultString.translations.AuthorizeNow }),
        _react2.default.createElement(_components.BaseButton, { className: _Authorization3.default.changeProvider, onClick: this.onChangeProvider, buttonString: _DefaultString.translations.ChangeProvider })
      );
    }
  }]);
  return Authorization;
}(_react.Component), _class2.propTypes = {
  appInfo: _react.PropTypes.object,
  auth: _react.PropTypes.object,
  log: _react.PropTypes.object,
  pushState: _react.PropTypes.func.isRequired,
  startGracePeriod: _react.PropTypes.func.isRequired
}, _temp)) || _class);
exports.default = (0, _reactIntl.injectIntl)(Authorization);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Authorization/Authorization.js
// module id = 1994
// module chunks = 0